<template>
  <div>
    <v-carousel 
      v-if="!isIE11"
      dark
      prev-icon="mdi-arrow-left"
      next-icon="mdi-arrow-right"      
    >
      <v-carousel-item
        v-for="i in 4" :key="i"
      >
        <Landing1 v-if="i===1" />
        <Landing2 v-if="i===2" />
        <Landing3 v-if="i===3" />
        <Landing4 v-if="i===4" />
      </v-carousel-item>
    </v-carousel>
    <v-carousel dark v-if="isIE11" :hide-delimiters="!delimiters" >
      <v-carousel-item>
        <Landing1 />
      </v-carousel-item>
    </v-carousel>  
  </div>
</template>

<script>
import Landing1 from 'components/Landing1.vue';
import Landing2 from 'components/Landing2.vue';
import Landing3 from 'components/Landing3.vue';
import Landing4 from 'components/Landing4.vue';
export default {
  components: {
    Landing1,
    Landing2,
    Landing3,
    Landing4,
  },    
  data () {
    return {
      delimiters: false,
      arrows: true,
      cycle: false,
    }
  },
  computed:{
    isIE11() {
      let rv = -1;
      if (navigator.appName == 'Microsoft Internet Explorer')
      {
        let ua = navigator.userAgent;
        let re = new RegExp("MSIE ([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) != null)
          rv = parseFloat( RegExp.$1 );
      }
      else if (navigator.appName == 'Netscape')
      {
        let ua = navigator.userAgent;
        let re  = new RegExp("Trident/.*rv:([0-9]{1,}[\\.0-9]{0,})");
        if (re.exec(ua) != null)
          rv = parseFloat( RegExp.$1 );
      }
      if(rv == 11) {
        return true
      }
      return false;
    }
  }
}
</script>

<style>
.bg{
  background-color: aquamarine !important;
}
</style>